/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { getSmartSize } from '../../utils/helpers/styles'
import { useBackgroundStyle } from '../../utils/styles/background'
import { useBorderStyle } from '../../utils/styles/border'
import { useCursorStyle } from '../../utils/styles/cursor'
import { useGridStyle } from '../../utils/styles/grid'
import { useMarginStyle } from '../../utils/styles/margin'
import ConditionalLink from '../actions/ConditionalLink'

const Circle = ({ onClick, children, color, size, ...props }) => {
  const sizeValue = getSmartSize(size, {}, 2)

  const style = css`
    ${useGridStyle({ justify: 'center', align: 'center', ...props })}
    ${useBorderStyle({ radius: 200, ...props })}
    ${useMarginStyle(props)}
    ${useBackgroundStyle({ bgColor: color || 'primary', ...props })}
    ${useCursorStyle(props)}
    width: ${sizeValue};
    height: ${sizeValue};
  `

  return (
    <ConditionalLink onClick={onClick} block>
      <div css={style} className="circle" {...props}>
        {children}
      </div>
    </ConditionalLink>
  )
}

export default Circle
